export default "__VITE_ASSET__ClS85Dzz__"